import type { Theme } from '@mui/material/styles';

export const useAppenderStyle = (theme: Theme) => ({
  item: {
    padding: theme.spacing(0.5),
    textAlign: 'center' as const,
    cursor: 'pointer',
    color: theme.palette.primary.main,
    '&:hover': {
      opacity: 0.6,
    },
  },
  disabled: {
    cursor: 'default',
    color: theme.palette.text.primary,
    opacity: 0.4,
  },
  templateHolder: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  img: {
    position: 'relative' as const,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingBottom: '5px',
    width: '80px',
    height: '80px',
    backgroundColor: theme.palette.custom.gray600,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    borderRadius: '5px',
    transition: 'width 0.15s, height 0.15s, margin 0.15s',
    '&:hover': {
      width: '140px',
      height: '140px',
      margin: '-30px',
      zIndex: 1,
    },
  },
  clickImg: {
    cursor: 'pointer',
  },
  stInfo: {
    padding: theme.spacing(1),
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column' as const,
  },
  addButton: {
    backgroundColor: '#00000055',
    color: '#fff',
    width: '100%',
    fontSize: '0.8rem',
    '& span': {
      fontSize: '1rem',
      marginRight: '5px',
      verticalAlign: 'text-bottom',
    },
  },
  edit: {
    opacity: 0.4,
    fontSize: '13px',
    '&:hover': {
      opacity: 1,
    },
  },
});
